export const cityList = ['Vancouver', 'Washington', 'Barcelona', 'Manchester', 'Wien', 'Brussels']
export const itemList = [
  {
    name: 'Matthew McCormick',
    email: 'matthew30@mail.ol',
    city: 'Vancouver',
    score: 93
  },
  {
    name: 'Nancy Bo',
    email: 'nancy@bonweb.com',
    city: 'Washington',
    score: 280
  },
  {
    name: 'Frederiko Lopez',
    email: 'fr.lopez@webmail.sp',
    city: 'Barcelona',
    score: 16
  },
  {
    name: 'Stanley Hummer',
    email: 'mr_winner_2999@gmail.cb',
    city: 'Manchester',
    score: 57
  },
  {
    name: 'Lendley Wintz',
    email: '9938198146@mailster.io',
    city: 'Wien',
    score: 113
  },
  {
    name: 'Barbara Noz',
    email: 'barbaranoz@mailster.io',
    city: 'Brussels',
    score: 68
  },
  {
    name: 'ancy Bo',
    email: 'nancy@boonweb.com',
    city: 'Washington',
    score: 280
  }
]
